// GENERATED by scripts/gen-vocab.ts — do not edit by hand. Run `npm run gen:vocab`.
// Sources: reference/schema_full.json (17 live lists) and docs/SCHEMA-V4-ADDITIONS.md (3 v4 lists
// + the RequestedRoleContext value "Tenant Self-Service"). Choice values exactly as stored.

export const vocab = {
  SM_AppointmentTransactions: {
    CreationSource: ["Power App", "Scheduled Flow", "Admin Manual", "Migration"],
    RequestedRoleContext: ["Scheduling and Program Staff", "Sensitive Service Reviewer", "Follow-Up Action Staff", "Volunteer Hours Verifier", "Administrator", "Tenant Self-Service"],
    RecordClass: ["Staff Operation", "Processor Action"],
    OperationType: ["Create Appointment", "Reschedule Appointment", "Cancel Appointment", "Record Tenant Confirmation Response", "Assign Volunteer", "Record Volunteer Response", "Unassign Volunteer", "Record No Show", "Record Unable To Complete", "Place Appointment On Hold", "Extend Appointment Hold", "Release Appointment Hold", "Start Service", "Reopen Appointment"],
    ProcessorAction: ["Not Applicable", "Release Reservation", "Expire Hold", "Reconcile Orphaned Reservation", "Retry Failed Transaction", "Apply Pattern Update"],
    ProcessingStatus: ["Pending", "Claimed", "In Progress", "Completed", "Rejected", "Failed", "Superseded"],
    ProcessingStage: ["Not Started", "Ingress Validated", "Authorized", "Idempotency Checked", "Business Validated", "Reservation Acquired", "Mutation Applied", "Communication Queued", "Audit Appended", "Committed"],
    PostCommitStatus: ["Not Applicable", "Pending", "Completed", "Failed"],
    CompensationStatus: ["Not Required", "Required", "In Progress", "Completed", "Failed"],
    RecoveryStatus: ["Not Required", "Awaiting Review", "Under Review", "Resolved", "Abandoned"],
    OutcomeCode: ["Applied", "Duplicate Ignored", "Capacity Full", "Surge Approval Required", "Weekly Conflict", "Authorization Exhausted", "Authorization Exception Required", "Blackout Date", "Eligibility Failed", "Outside Service Window", "Slot Not Open", "Tenant Inactive", "Enrollment Inactive", "Validation Error", "Concurrency Conflict", "Unsupported Payload Version", "Not Authorized", "System Error"],
    RequestedServicePeriod: ["Morning", "Afternoon", "Evening", "Flexible", "All Day", "Not Applicable"],
    RequestedReservationDisposition: ["Not Applicable", "Acquire", "Retain Until Hold Until", "Release Immediately"],
    ResultingReservationDisposition: ["Not Applicable", "Acquire", "Retain Until Hold Until", "Release Immediately"],
    PriorStatusSnapshot: ["Not Applicable", "Proposed", "Scheduled", "On Hold", "In Progress", "Completed", "Cancelled", "No Show", "Unable to Complete", "Rescheduled"],
    TenantResponseOutcome: ["Not Applicable", "Confirmed", "Declined", "Unable To Reach"],
    TenantResponseMethod: ["Email", "Phone Call", "Text Message", "In Person", "Other", "Not Applicable"],
    VolunteerResponseOutcome: ["Not Applicable", "Confirmed", "Declined", "No Response"],
    OutcomeReasonCategory: ["Not Applicable", "Tenant Unavailable", "Volunteer Unavailable", "Staffing Shortage", "Building Closure", "Weather", "Health or Safety Concern", "Scheduling Error", "Duplicate Appointment", "Program Change", "Other"],
    CancellationInitiatedBy: ["Not Applicable", "Tenant", "Volunteer", "Housekeeping Team", "Staff", "Building Closure", "Weather", "Safety Concern", "Other"],
    AuthorizationExceptionStatus: ["Not Required", "Pending", "Approved", "Denied", "Expired"],
  },
  SM_Appointments: {
    CreationSource: ["Manual", "Monthly Proposal Generation", "One-Time Request", "Reschedule", "Intake Request", "Import", "Group Event"],
    ServicePeriod: ["Morning", "Afternoon", "Evening", "Flexible", "All Day", "Not Applicable"],
    ServiceLocationType: ["Tenant Unit", "Building Common Area", "Remote", "Community Location", "Off-site Event", "Other", "Not Determined"],
    AppointmentStatus: ["Proposed", "Scheduled", "On Hold", "In Progress", "Completed", "Cancelled", "No Show", "Unable to Complete", "Rescheduled"],
    PatternChangeScope: ["Not Applicable", "This Appointment Only", "This and Future Appointments"],
    PatternUpdateStatus: ["Not Required", "Pending", "Completed", "Failed"],
    TenantConfirmationStatus: ["Not Requested", "Pending", "Confirmed", "Declined", "Unable to Reach", "Not Required"],
    TenantConfirmationMethod: ["Email", "Phone Call", "Text Message", "In Person", "Other", "Not Applicable"],
    VolunteerAssignmentStatus: ["Not Required", "Unassigned", "Candidate Identified", "Offer Sent", "Confirmed", "Declined", "Replacement Needed", "Cancelled"],
    AuthorizationStatus: ["Not Checked", "Valid", "Warning", "Over Limit - Approval Required", "Approved Exception", "Invalid Enrollment", "Not Applicable"],
    CancellationInitiatedBy: ["Not Applicable", "Tenant", "Volunteer", "Housekeeping Team", "Staff", "Building Closure", "Weather", "Safety Concern", "Other"],
    CancellationReasonCategory: ["Not Applicable", "Tenant Unavailable", "Volunteer Unavailable", "Staffing Shortage", "Building Closure", "Weather", "Health or Safety Concern", "Scheduling Error", "Duplicate Appointment", "Program Change", "Other"],
    RescheduleStatus: ["Not Required", "Requested", "In Progress", "Completed", "Unable to Reschedule", "Declined"],
    CompletionRecordStatus: ["Not Started", "Draft", "Submitted", "Reviewed", "Not Required"],
    ReservationState: ["None", "Acquiring", "Reserved", "Release Pending", "Released", "Error"],
  },
  SM_AuditLog: {
    EventCategory: ["Scheduling", "Capacity", "Authorization", "Eligibility", "Volunteer Management", "Communication", "Follow-Up", "Documentation", "Volunteer Hours", "Security and Permissions", "Administrative Override", "Data Correction", "Migration", "System"],
    EventOutcome: ["Succeeded", "Failed", "Partial", "Skipped", "Not Required"],
    Severity: ["Informational", "Notable", "Warning", "Critical"],
    ActorType: ["Automation", "Staff User", "Administrator", "System"],
    SourceSystem: ["Power Automate", "Power Apps", "SharePoint UI", "Manual Entry", "Migration", "Other"],
    TargetRecordType: ["Appointment", "Service Completion", "Unit Condition Assessment", "Communication", "Follow-Up Action", "Volunteer Service Hours", "Tenant", "Volunteer", "Enrollment", "Housekeeping Slot", "Service Cycle", "Blackout Date", "Email Template", "Document", "Program", "Setting", "Migration Batch", "Migration Record", "System"],
    ParentRecordType: ["Appointment", "Service Completion", "Unit Condition Assessment", "Communication", "Follow-Up Action", "Volunteer Service Hours", "Tenant", "Volunteer", "Enrollment", "Housekeeping Slot", "Service Cycle", "Blackout Date", "Email Template", "Document", "Program", "Setting", "Migration Batch", "Migration Record", "System"],
  },
  SM_BlackoutDates: {
    ProgramGroup: ["All Programs", "Housekeeping", "Reading Services", "Community Companion and Wellness"],
    BlackoutType: ["Holiday", "Building Closure", "Program Closure", "Emergency Closure", "Weather Closure", "Other"],
  },
  SM_Communications: {
    SourceType: ["Appointment", "Service Completion", "Unit Condition Assessment", "Follow-Up Action", "Enrollment", "Volunteer", "Document Filing", "Program Administration", "Manual", "Other"],
    CommunicationType: ["Appointment Notice", "Appointment Reminder", "Cancellation Notice", "Rescheduling Notice", "Tenant Cancellation Confirmation", "Volunteer Assignment", "Volunteer Reminder", "Volunteer Cancellation", "Volunteer Replacement Needed", "Internal Staff Alert", "Unit Condition or Safety Alert", "Follow-Up Communication", "Other"],
    RecipientType: ["Tenant", "Volunteer", "Housekeeping Team", "Internal Staff", "External Contact", "Other"],
    CommunicationStatus: ["Draft", "Pending Approval", "Queued", "Attempting", "Sent", "Cancelled", "Superseded", "Not Required", "Logged Manually"],
    DeliveryStatus: ["Not Applicable", "Pending", "Delivered", "Failed", "Undeliverable", "Bounced", "No Response Needed", "Unknown"],
    Channel: ["Email", "Phone Call", "Voicemail", "Text Message", "In-Person", "Letter", "System Notification", "Other"],
    Direction: ["Outbound", "Inbound", "Internal"],
  },
  SM_EmailTemplates: {
    ProgramGroup: ["All Programs", "Housekeeping", "Reading Services", "Community Companion and Wellness", "Internal Staff"],
    CommunicationType: ["Appointment Notice", "Appointment Reminder", "Cancellation Notice", "Rescheduling Notice", "Tenant Cancellation Confirmation", "Volunteer Assignment", "Volunteer Reminder", "Volunteer Cancellation", "Volunteer Replacement Needed", "Internal Staff Alert", "Unit Condition or Safety Alert", "Follow-Up Communication", "Other"],
    RecipientType: ["Tenant", "Volunteer", "Housekeeping Team", "Internal Staff", "Tenant and Volunteer", "Other"],
  },
  SM_FollowUpActions: {
    SourceType: ["Service Completion", "Unit Condition Assessment", "Communication", "Appointment", "Enrollment", "Volunteer", "Document Filing", "Scheduling", "Program Administration", "Manual", "Migration", "Other"],
    FollowUpCategory: ["Additional Housekeeping", "Tenant Interaction", "Unit Condition", "Maintenance or Repair", "Pest Control", "Biohazard Remediation", "Safety", "Scheduling", "Volunteer Support", "Tenant Support", "Program Support", "Document Filing", "Communication", "Other"],
    Status: ["Open", "Assigned", "In Progress", "Waiting for Information", "Waiting for External Action", "Resolved", "Closed", "Cancelled", "Duplicate"],
    Priority: ["Routine", "Prompt", "Urgent", "Immediate"],
    AssignedGroup: ["Not Assigned", "SM Follow-Up Action Staff", "Scheduling and Program Staff", "Service Documentation Editors", "Building Management", "Program Leadership", "External Agency", "Other"],
    EscalationLevel: ["None", "Supervisor", "Management", "Building Management", "External Agency"],
    ResolutionStatus: ["Not Resolved", "Resolved", "Referred", "No Action Needed", "Duplicate", "Unable to Resolve", "Cancelled"],
    CreationSource: ["Power Automate", "Power Apps", "Manual Entry", "Migration"],
  },
  SM_HousekeepingCapacityTransactions: {
    CreationSource: ["Power App", "Scheduled Flow", "Admin Manual", "Migration"],
    RequestedRoleContext: ["Scheduling and Program Staff", "Sensitive Service Reviewer", "Follow-Up Action Staff", "Volunteer Hours Verifier", "Administrator"],
    RecordClass: ["Staff Operation", "Processor Action"],
    OperationType: ["Approve Surge", "Revoke Surge Approval"],
    ProcessorAction: ["Not Applicable", "Expire Surge Approval", "Retry Failed Transaction"],
    ProcessingStatus: ["Pending", "Claimed", "In Progress", "Completed", "Rejected", "Failed", "Superseded"],
    ProcessingStage: ["Not Started", "Ingress Validated", "Authorized", "Idempotency Checked", "Business Validated", "Reservation Acquired", "Mutation Applied", "Communication Queued", "Audit Appended", "Committed"],
    PostCommitStatus: ["Not Applicable", "Pending", "Completed", "Failed"],
    CompensationStatus: ["Not Required", "Required", "In Progress", "Completed", "Failed"],
    RecoveryStatus: ["Not Required", "Awaiting Review", "Under Review", "Resolved", "Abandoned"],
    OutcomeCode: ["Applied", "Duplicate Ignored", "Capacity Full", "Surge Approval Required", "Surge In Use", "Weekly Conflict", "Authorization Exhausted", "Authorization Exception Required", "Blackout Date", "Eligibility Failed", "Outside Service Window", "Slot Not Open", "Tenant Inactive", "Enrollment Inactive", "Validation Error", "Concurrency Conflict", "Unsupported Payload Version", "Not Authorized", "System Error"],
    ApprovalStatus: ["Not Required", "Pending", "Approved", "Denied", "Expired"],
    DecisionReasonCategory: ["Not Applicable", "Anticipated Demand", "Backlog Recovery", "Tenant Urgency", "Crew Availability", "Other"],
    RevocationReasonCategory: ["Not Applicable", "Crew No Longer Available", "Approved In Error", "Demand Reduced", "Building Closure", "Other"],
  },
  SM_HousekeepingSlots: {
    SlotStatus: ["Draft", "Open for Scheduling", "Closed to New Appointments", "Cancelled", "Completed"],
    CrewReadinessStatus: ["Not Reviewed", "Ready", "Short Staffed", "Unavailable"],
    GenerationSource: ["Manual", "Monthly Generation", "Imported"],
  },
  SM_Programs: {
    SM_Programs: ["Housekeeping", "Reading Services", "Community Companion and Wellness"],
  },
  SM_ServiceCompletionTransactions: {
    CreationSource: ["Power App", "Scheduled Flow", "Admin Manual", "Migration"],
    RequestedRoleContext: ["Scheduling and Program Staff", "Sensitive Service Reviewer", "Follow-Up Action Staff", "Volunteer Hours Verifier", "Administrator"],
    RecordClass: ["Staff Operation", "Processor Action"],
    OperationType: ["Record Completion", "Return Completion For Correction", "Void Completion"],
    ProcessorAction: ["Not Applicable", "Retry Failed Transaction"],
    ProcessingStatus: ["Pending", "Claimed", "In Progress", "Completed", "Rejected", "Failed", "Superseded"],
    ProcessingStage: ["Not Started", "Ingress Validated", "Authorized", "Idempotency Checked", "Business Validated", "Reservation Acquired", "Mutation Applied", "Communication Queued", "Audit Appended", "Committed"],
    PostCommitStatus: ["Not Applicable", "Pending", "Completed", "Failed"],
    CompensationStatus: ["Not Required", "Required", "In Progress", "Completed", "Failed"],
    RecoveryStatus: ["Not Required", "Awaiting Review", "Under Review", "Resolved", "Abandoned"],
    OutcomeCode: ["Applied", "Duplicate Ignored", "Capacity Full", "Surge Approval Required", "Weekly Conflict", "Authorization Exhausted", "Authorization Exception Required", "Blackout Date", "Eligibility Failed", "Outside Service Window", "Slot Not Open", "Tenant Inactive", "Enrollment Inactive", "Validation Error", "Concurrency Conflict", "Unsupported Payload Version", "Not Authorized", "System Error"],
    RequestedCompletionStatus: ["Draft", "Submitted", "Returned for Correction", "Reviewed", "Closed", "Voided"],
    ServiceOutcome: ["Not Applicable", "Completed", "Partially Completed", "Unable to Complete", "Tenant Unavailable", "Service Declined", "Staff Safety Stop", "Other"],
    ServiceConditionLevel: ["Not Applicable", "Routine - Nothing to Report", "Elevated Cleaning Need", "Potential Health or Safety Concern"],
    ReturnReasonCategory: ["Not Applicable", "Incomplete Information", "Incorrect Outcome", "Missing Documentation", "Assessment Required", "Other"],
    VoidReasonCategory: ["Not Applicable", "Duplicate Record", "Wrong Appointment", "Entered In Error", "Service Did Not Occur", "Other"],
    AppointmentSyncOutcome: ["Not Started", "Pending", "Completed", "Failed", "Not Required"],
  },
  SM_ServiceCompletions: {
    CompletionStatus: ["Draft", "Submitted", "Returned for Correction", "Reviewed", "Closed", "Voided"],
    SubmissionSource: ["Power App", "Manual", "Import", "Automation"],
    ServiceOutcome: ["Completed", "Partially Completed", "Unable to Complete", "Tenant Unavailable", "Service Declined", "Staff Safety Stop", "Other"],
    ServiceConditionLevel: ["Not Applicable", "Routine - Nothing to Report", "Elevated Cleaning Need", "Potential Health or Safety Concern"],
    UnitConditionAssessmentStatus: ["Not Required", "Pending", "In Progress", "Submitted", "Reviewed", "Unable to Complete"],
    PhotoDocumentationStatus: ["Not Added", "Pending Upload", "Filed", "Failed", "Not Permitted"],
    FollowUpPriority: ["Not Applicable", "Routine", "Prompt", "Urgent", "Immediate"],
    FollowUpCategory: ["Not Applicable", "Additional Housekeeping", "Tenant Interaction", "Unit Condition", "Maintenance or Repair", "Safety", "Scheduling", "Program Support", "Other"],
    FollowUpStatus: ["Not Required", "Open", "In Progress", "Completed", "Closed No Action"],
    DocumentFilingStatus: ["Not Started", "Pending", "Filed", "Failed", "Not Required"],
    AppointmentSyncStatus: ["Not Started", "Pending", "Completed", "Failed", "Not Required"],
  },
  SM_ServiceCycles: {
    CycleType: ["Calendar Month", "Four-Week Cycle", "Custom Authorization Period"],
    ProgramGroup: ["Housekeeping", "Reading Services", "Community Companion and Wellness", "All Programs"],
  },
  SM_Settings: {
    ValueType: ["Text", "Number", "Yes/No", "Time", "Time", "Email"],
    Category: ["General", "Housekeeping", "Reading Services", "Community Companion and Wellness", "Volunteers", "Communications", "System", "Eligibility"],
  },
  SM_TenantProgramEnrollments: {
    EnrollmentStatus: ["Pending Review", "Active", "Paused", "Waitlisted", "Ended", "Not Approved"],
    AuthorizationBasis: ["Calendar Month", "Calendar Week", "Authorization Period", "No Fixed Limit", "Not Applicable", "Other"],
    SchedulingMethod: ["Monthly Standing Pattern", "Weekly Standing Pattern", "As Needed", "Manual Scheduling", "Event Based"],
    PrimaryWeekOfMonth: ["First", "Second", "Third", "Fourth", "Last", "Flexible", "Not Applicable"],
    PrimaryDayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "Flexible", "Not Applicable"],
    PrimaryServicePeriod: ["Morning", "Afternoon", "Flexible", "Not Applicable"],
    SecondaryWeekOfMonth: ["First", "Second", "Third", "Fourth", "Last", "Flexible", "Not Applicable"],
    SecondaryDayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "Flexible", "Not Applicable"],
    SecondaryServicePeriod: ["Morning", "Afternoon", "Flexible", "Not Applicable"],
    EligibilityStatus: ["Not Evaluated", "Pending Documentation", "Eligible", "Temporarily Ineligible", "Ineligible", "Expired"],
    QueueStatus: ["Not Applicable", "Not Ready", "Ready for Proposal Generation", "Waitlisted", "On Hold", "Closed"],
    HousekeepingWaiverReceivedMethod: ["Not Recorded", "Paper", "Email", "Electronic Form", "In Person", "Other"],
    ServiceSafetyHoldCategory: ["Not Applicable", "Staff Safety", "Unit Condition", "Access", "Maintenance or Repair", "Public Health", "Program Administration", "Other"],
  },
  SM_Tenants: {
    PreferredContactMethod: ["Email", "Phone Call", "Text Message", "In Person", "No Preference", "Other"],
    TenantStatus: ["Active", "Temporarily Inactive", "Moved Out"],
    TenantCategory: ["Tenant", "Staff"],
  },
  SM_UnitConditionAssessments: {
    AssessmentStatus: ["Draft", "Submitted", "Returned for Correction", "Reviewed", "Closed", "Unable to Complete", "Voided"],
    SubmissionSource: ["Power App", "Manual", "Import", "Automation"],
    PrimaryConditionCategory: ["Walkways, doors, or exits obstructed", "Excessive accumulation interfering with service or safe movement", "Pest activity", "Spoiled food, trash, or waste", "Animal waste", "Strong odor or possible air-quality concern", "Bodily fluids, sharps, or other possible biohazard", "Fire or electrical hazard", "Water damage or possible mold", "Plumbing concern", "Structural concern", "Sanitation concern", "Utility concern", "Hazardous substances or unsafe materials", "Other observable concern"],
    AssessmentSeverityLevel: ["Elevated Cleaning Need", "Potential Health or Safety Concern", "Immediate Danger"],
    UrgentAlertStatus: ["Not Required", "Pending", "Sent", "Failed"],
    EffectOnScheduledService: ["No Effect", "Partially Limited", "Service Stopped", "Unable to Begin Service"],
    FollowUpPriority: ["Not Applicable", "Routine", "Prompt", "Urgent", "Immediate"],
    FollowUpCategory: ["Not Applicable", "Additional Housekeeping", "Unit Condition", "Maintenance or Repair", "Pest Control", "Biohazard Remediation", "Safety", "Tenant Support", "Program Support", "Other"],
    PhotoDocumentationStatus: ["Not Added", "Pending Upload", "Filed", "Failed", "Not Permitted"],
    DocumentFilingStatus: ["Not Started", "Pending", "Filed", "Failed", "Not Required"],
    CompletionSyncStatus: ["Not Started", "Pending", "Completed", "Failed", "Not Required"],
  },
  SM_TenantFeedback: {
    Channel: ["Email link", "Entered in person", "Phone call"],
    FormLanguage: ["English", "Spanish"],
    BelongingsCare: ["Yes", "No", "Somewhat", "Not Answered"],
    ContinueService: ["Yes", "No", "Not Answered"],
    FeedbackStatus: ["New", "Reviewed", "Acknowledged", "Resolved", "Closed"],
  },
  SM_Events: {
    SpotRule: ["Everyone", "First Come", "Raffle"],
    Audience: ["Tenants", "Volunteers", "Both"],
    VolunteerAudience: ["Not Applicable", "Event Support", "All"],
    EventStatus: ["Draft", "Invitations Sent", "RSVPs Open", "RSVPs Closed", "Raffle Drawn", "Completed", "Cancelled"],
  },
  SM_EventRSVPs: {
    PersonType: ["Tenant", "Special Guest", "Group Volunteer", "Individual Volunteer"],
    Coming: ["Yes", "No", "No Answer", "Withdrawn"],
    Accessibility: ["None", "Wheelchair", "Walker", "Cane", "Guide Dog", "Low Vision", "Blind", "Hearing Impaired"],
    Transportation: ["Bus", "MTA Transit", "Uber", "Own ride", "Pickup needed", "N/A"],
    RaffleOutcome: ["Not Applicable", "Winner", "Standby", "Not Drawn", "Withdrawn"],
    CallOutcome: ["Not Applicable", "Confirmed", "No Answer", "Declined", "Left a Message"],
    EntryChannel: ["Link", "Staff Entered", "Imported"],
    RSVPStatus: ["Active", "Superseded", "Voided"],
  },
} as const;

export type Vocab = typeof vocab;
export type ListName = keyof Vocab;
export type ChoiceOf<L extends ListName, C extends keyof Vocab[L]> =
  Vocab[L][C] extends readonly (infer T)[] ? T : never;

/** Every list the app knows by name: the 17 in the snapshot, then the three v4 lists. */
export const SNAPSHOT_LISTS = ["SM_AppointmentTransactions", "SM_Appointments", "SM_AuditLog", "SM_BlackoutDates", "SM_Communications", "SM_EmailTemplates", "SM_FollowUpActions", "SM_HousekeepingCapacityTransactions", "SM_HousekeepingSlots", "SM_Programs", "SM_ServiceCompletionTransactions", "SM_ServiceCompletions", "SM_ServiceCycles", "SM_Settings", "SM_TenantProgramEnrollments", "SM_Tenants", "SM_UnitConditionAssessments"] as const;
export const V4_LISTS = ["SM_TenantFeedback", "SM_Events", "SM_EventRSVPs"] as const;
export const ALL_LISTS = [...SNAPSHOT_LISTS, ...V4_LISTS] as const;

export interface ColumnDef { type: string; required: boolean; unique: boolean; maxLength?: number; multi?: boolean; defaultValue?: string; indexed?: boolean }

/** Column names and types per list (snapshot lists from schema_full.json; v4 lists from the doc). */
export const columns: Record<string, Record<string, ColumnDef>> = {
  SM_AppointmentTransactions: {
    TransactionID: { type: "Text", required: true, unique: true },
    IdempotencyKey: { type: "Text", required: true, unique: true },
    CorrelationID: { type: "Text", required: true, unique: false },
    SubmittedDateTime: { type: "DateTime", required: true, unique: false },
    CreationSource: { type: "Choice", required: true, unique: false },
    RequestedByUser: { type: "User", required: false, unique: false },
    RequestedByEmailSnapshot: { type: "Text", required: true, unique: false },
    RequestedRoleContext: { type: "Choice", required: true, unique: false },
    RecordClass: { type: "Choice", required: true, unique: false },
    OperationType: { type: "Choice", required: false, unique: false },
    ProcessorAction: { type: "Choice", required: true, unique: false },
    ProcessingStatus: { type: "Choice", required: true, unique: false },
    ProcessingStage: { type: "Choice", required: true, unique: false },
    PostCommitStatus: { type: "Choice", required: true, unique: false },
    CompensationStatus: { type: "Choice", required: true, unique: false },
    RecoveryStatus: { type: "Choice", required: true, unique: false },
    ClaimedByRunID: { type: "Text", required: false, unique: false },
    ClaimedDateTime: { type: "DateTime", required: false, unique: false },
    ProcessingAttempts: { type: "Number", required: true, unique: false },
    LastAttemptDateTime: { type: "DateTime", required: false, unique: false },
    NextRetryEligibleDateTime: { type: "DateTime", required: false, unique: false },
    ProcessedDateTime: { type: "DateTime", required: false, unique: false },
    OutcomeCode: { type: "Choice", required: false, unique: false },
    OutcomeMessage: { type: "Text", required: false, unique: false },
    OutcomeIsRetryable: { type: "Boolean", required: true, unique: false },
    ResultingRecordID: { type: "Text", required: false, unique: false },
    ResultingAuditEventID: { type: "Text", required: false, unique: false },
    RequestSnapshotJSON: { type: "Note", required: true, unique: false },
    RequestSnapshotVersion: { type: "Text", required: true, unique: false },
    ExpectedCommunicationSetSnapshot: { type: "Note", required: true, unique: false },
    TargetAppointmentID: { type: "Text", required: false, unique: false },
    TargetTenantID: { type: "Text", required: true, unique: false },
    TargetEnrollmentID: { type: "Text", required: false, unique: false },
    TargetProgramCode: { type: "Text", required: true, unique: false },
    TargetServiceDateKey: { type: "Text", required: false, unique: false },
    RequestedServiceDate: { type: "DateTime", required: false, unique: false },
    RequestedServicePeriod: { type: "Choice", required: true, unique: false },
    RequestedStartTimeMinutes: { type: "Number", required: false, unique: false },
    RequestedDurationMinutes: { type: "Number", required: false, unique: false },
    RequestedCapacityPosition: { type: "Number", required: false, unique: false },
    RequestedVolunteerID: { type: "Text", required: false, unique: false },
    RequestedReservationDisposition: { type: "Choice", required: true, unique: false },
    HoldUntil: { type: "DateTime", required: false, unique: false },
    ResultingReservationDisposition: { type: "Choice", required: true, unique: false },
    ReservationKeyAttempted: { type: "Text", required: false, unique: false },
    PriorStatusSnapshot: { type: "Choice", required: true, unique: false },
    TenantResponseOutcome: { type: "Choice", required: true, unique: false },
    TenantResponseMethod: { type: "Choice", required: true, unique: false },
    VolunteerResponseOutcome: { type: "Choice", required: true, unique: false },
    OutcomeReasonCategory: { type: "Choice", required: true, unique: false },
    CancellationInitiatedBy: { type: "Choice", required: true, unique: false },
    ReopenReason: { type: "Note", required: false, unique: false },
    AuthorizationExceptionRequested: { type: "Boolean", required: true, unique: false },
    AuthorizationExceptionStatus: { type: "Choice", required: true, unique: false },
    AuthorizationExceptionReason: { type: "Note", required: false, unique: false },
    AuthorizationExceptionApprovedBy: { type: "User", required: false, unique: false },
    AuthorizationExceptionApprovedDa: { type: "DateTime", required: false, unique: false },
    ProposalBatchID: { type: "Text", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_Appointments: {
    AppointmentID: { type: "Text", required: true, unique: true },
    AppointmentGenerationKey: { type: "Text", required: true, unique: true },
    RootAppointmentID: { type: "Text", required: true, unique: false },
    ProposalBatchID: { type: "Text", required: false, unique: false },
    GroupEventKey: { type: "Text", required: false, unique: false },
    CreationSource: { type: "Choice", required: true, unique: false },
    GeneratedDateTime: { type: "DateTime", required: false, unique: false },
    TenantIDSnapshot: { type: "Text", required: true, unique: false },
    TenantNameSnapshot: { type: "Text", required: true, unique: false },
    UnitNumberAtService: { type: "Text", required: true, unique: false },
    ProgramCodeSnapshot: { type: "Text", required: true, unique: false },
    AuthorizationPeriodKey: { type: "Text", required: true, unique: false },
    ServiceDate: { type: "DateTime", required: true, unique: false },
    ServicePeriod: { type: "Choice", required: true, unique: false },
    StartTimeMinutes: { type: "Number", required: false, unique: false },
    EndTimeMinutes: { type: "Number", required: false, unique: false },
    PlannedDurationMinutes: { type: "Number", required: true, unique: false },
    DailySequenceNumber: { type: "Number", required: false, unique: false },
    ServiceLocationType: { type: "Choice", required: true, unique: false },
    LocationDetails: { type: "Text", required: false, unique: false },
    AppointmentStatus: { type: "Choice", required: true, unique: false },
    IsOnMainSchedule: { type: "Boolean", required: false, unique: false },
    PatternChangeScope: { type: "Choice", required: true, unique: false },
    PatternUpdateStatus: { type: "Choice", required: true, unique: false },
    PatternUpdateProcessedDateTime: { type: "DateTime", required: false, unique: false },
    TenantConfirmationStatus: { type: "Choice", required: true, unique: false },
    TenantConfirmationMethod: { type: "Choice", required: true, unique: false },
    TenantConfirmationDateTime: { type: "DateTime", required: false, unique: false },
    TenantConfirmationNotes: { type: "Note", required: false, unique: false },
    VolunteerRequired: { type: "Boolean", required: false, unique: false },
    VolunteerAssignmentStatus: { type: "Choice", required: true, unique: false },
    VolunteerOfferSentDateTime: { type: "DateTime", required: false, unique: false },
    VolunteerConfirmedDateTime: { type: "DateTime", required: false, unique: false },
    VolunteerAssignmentNotes: { type: "Note", required: false, unique: false },
    AuthorizationUnits: { type: "Number", required: true, unique: false },
    CountsAgainstAuthorization: { type: "Boolean", required: false, unique: false },
    AuthorizationStatus: { type: "Choice", required: true, unique: false },
    CountsTowardCapacity: { type: "Boolean", required: false, unique: false },
    UsesSurgeCapacity: { type: "Boolean", required: false, unique: false },
    CancellationInitiatedBy: { type: "Choice", required: true, unique: false },
    CancellationReasonCategory: { type: "Choice", required: true, unique: false },
    CancellationReason: { type: "Note", required: false, unique: false },
    CancelledDateTime: { type: "DateTime", required: false, unique: false },
    RescheduleStatus: { type: "Choice", required: true, unique: false },
    RescheduledFromAppointmentID: { type: "Text", required: false, unique: false },
    RescheduledToAppointmentID: { type: "Text", required: false, unique: false },
    RescheduleReason: { type: "Note", required: false, unique: false },
    RescheduledDateTime: { type: "DateTime", required: false, unique: false },
    CompletionRequired: { type: "Boolean", required: false, unique: false },
    CompletionRecordStatus: { type: "Choice", required: true, unique: false },
    CompletionRecordID: { type: "Text", required: false, unique: false },
    CompletionSubmittedDateTime: { type: "DateTime", required: false, unique: false },
    FollowUpRequired: { type: "Boolean", required: false, unique: false },
    DocumentationFolderLink: { type: "URL", required: false, unique: false },
    AppointmentNotes: { type: "Note", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    ScheduleConfirmedBy: { type: "User", required: false, unique: false },
    ScheduleConfirmedDateTime: { type: "DateTime", required: false, unique: false },
    CancelledBy: { type: "User", required: false, unique: false },
    RescheduledBy: { type: "User", required: false, unique: false },
    Program: { type: "Lookup", required: true, unique: false },
    ServiceCycle: { type: "Lookup", required: false, unique: false },
    HousekeepingSlotIDSnapshot: { type: "Text", required: false, unique: false },
    HousekeepingWeekStartDate: { type: "DateTime", required: false, unique: false },
    EnrollmentIDSnapshot: { type: "Text", required: false, unique: false },
    ServiceCycleCodeSnapshot: { type: "Text", required: false, unique: false },
    ReservationState: { type: "Choice", required: true, unique: false },
    ReservationAcquiredDateTime: { type: "DateTime", required: false, unique: false },
    ReservationReleasedDateTime: { type: "DateTime", required: false, unique: false },
    ActiveCapacityReservationKey: { type: "Text", required: false, unique: true },
    ActiveHousekeepingWeekKey: { type: "Text", required: false, unique: true },
    StaffOwner: { type: "User", required: false, unique: false },
    TenantPhoneSnapshot: { type: "Text", required: false, unique: false },
    VolunteerIDSnapshot: { type: "Text", required: false, unique: false },
    VolunteerNameSnapshot: { type: "Text", required: false, unique: false },
    VolunteerPhoneSnapshot: { type: "Text", required: false, unique: false },
    VolunteerEmailSnapshot: { type: "Text", required: false, unique: false },
    AppointmentPurpose: { type: "Text", required: false, unique: false },
    StartingLocation: { type: "Text", required: false, unique: false },
    Destination: { type: "Text", required: false, unique: false },
    MeetingInstructions: { type: "Note", required: false, unique: false },
    Tenant: { type: "Lookup", required: true, unique: false },
    Enrollment: { type: "Lookup", required: true, unique: false },
    HousekeepingSlot: { type: "Lookup", required: false, unique: false },
    AssignedVolunteer: { type: "Lookup", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_AuditLog: {
    AuditEventID: { type: "Text", required: true, unique: true },
    AuditEventKey: { type: "Text", required: true, unique: true },
    CorrelationID: { type: "Text", required: true, unique: false },
    EventDateTime: { type: "DateTime", required: true, unique: false },
    EventCategory: { type: "Choice", required: true, unique: false },
    EventCode: { type: "Text", required: true, unique: false },
    EventOccurrenceTag: { type: "Text", required: true, unique: false },
    EventOutcome: { type: "Choice", required: true, unique: false },
    Severity: { type: "Choice", required: true, unique: false },
    ActorType: { type: "Choice", required: true, unique: false },
    ActorUser: { type: "User", required: false, unique: false },
    ActorNameSnapshot: { type: "Text", required: false, unique: false },
    ActorEmailSnapshot: { type: "Text", required: false, unique: false },
    SourceSystem: { type: "Choice", required: true, unique: false },
    SourceFlowName: { type: "Text", required: false, unique: false },
    AutomationRunID: { type: "Text", required: false, unique: false },
    TargetRecordType: { type: "Choice", required: true, unique: false },
    TargetRecordID: { type: "Text", required: true, unique: false },
    TargetRecordDisplayNameSnapshot: { type: "Text", required: false, unique: false },
    ParentRecordType: { type: "Choice", required: false, unique: false },
    ParentRecordID: { type: "Text", required: false, unique: false },
    TenantIDSnapshot: { type: "Text", required: false, unique: false },
    VolunteerIDSnapshot: { type: "Text", required: false, unique: false },
    AppointmentIDSnapshot: { type: "Text", required: false, unique: false },
    ProgramCodeSnapshot: { type: "Text", required: false, unique: false },
    ChangeSummary: { type: "Note", required: false, unique: false },
    ChangeReason: { type: "Text", required: false, unique: false },
    OverrideUsed: { type: "Boolean", required: true, unique: false },
    OverrideApprovedBy: { type: "User", required: false, unique: false },
    SensitiveEvent: { type: "Boolean", required: true, unique: false },
    RelatedRecordLink: { type: "URL", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_BlackoutDates: {
    BlackoutCode: { type: "Text", required: true, unique: true },
    BlackoutName: { type: "Text", required: true, unique: false },
    ProgramGroup: { type: "Choice", required: true, unique: false },
    StartDateTime: { type: "DateTime", required: true, unique: false },
    EndDateTime: { type: "DateTime", required: true, unique: false },
    AllDay: { type: "Boolean", required: false, unique: false },
    BlackoutType: { type: "Choice", required: true, unique: false },
    SM_BlackoutDates: { type: "Note", required: false, unique: false },
    Active: { type: "Boolean", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_Communications: {
    CommunicationID: { type: "Text", required: true, unique: true },
    CommunicationKey: { type: "Text", required: true, unique: true },
    SourceType: { type: "Choice", required: true, unique: false },
    SourceRecordID: { type: "Text", required: false, unique: false },
    CommunicationType: { type: "Choice", required: true, unique: false },
    RecipientType: { type: "Choice", required: true, unique: false },
    RecipientIdentifierSnapshot: { type: "Text", required: true, unique: false },
    RecipientNameSnapshot: { type: "Text", required: false, unique: false },
    RecipientContactSnapshot: { type: "Text", required: false, unique: false },
    OccurrenceTag: { type: "Text", required: true, unique: false },
    AppointmentIDSnapshot: { type: "Text", required: false, unique: false },
    TenantIDSnapshot: { type: "Text", required: false, unique: false },
    VolunteerIDSnapshot: { type: "Text", required: false, unique: false },
    EnrollmentIDSnapshot: { type: "Text", required: false, unique: false },
    ProgramCodeSnapshot: { type: "Text", required: false, unique: false },
    TriggerEvent: { type: "Text", required: false, unique: false },
    CommunicationStatus: { type: "Choice", required: true, unique: false },
    DeliveryStatus: { type: "Choice", required: true, unique: false },
    ScheduledSendDateTime: { type: "DateTime", required: false, unique: false },
    AttemptedDateTime: { type: "DateTime", required: false, unique: false },
    DeliveredDateTime: { type: "DateTime", required: false, unique: false },
    FailedDateTime: { type: "DateTime", required: false, unique: false },
    FailureReason: { type: "Note", required: false, unique: false },
    RetryCount: { type: "Number", required: true, unique: false },
    MaxRetries: { type: "Number", required: true, unique: false },
    TemplateKeySnapshot: { type: "Text", required: false, unique: false },
    TemplateVersionSnapshot: { type: "Text", required: false, unique: false },
    MessageSubjectSnapshot: { type: "Text", required: false, unique: false },
    MessageSummary: { type: "Note", required: false, unique: false },
    Channel: { type: "Choice", required: true, unique: false },
    Direction: { type: "Choice", required: true, unique: false },
    ResponseReceived: { type: "Boolean", required: true, unique: false },
    ResponseSummary: { type: "Note", required: false, unique: false },
    ResponseDateTime: { type: "DateTime", required: false, unique: false },
    FollowUpRequired: { type: "Boolean", required: true, unique: false },
    FollowUpActionIDSnapshot: { type: "Text", required: false, unique: false },
    OwnerUser: { type: "User", required: false, unique: false },
    CorrelationID: { type: "Text", required: true, unique: false },
    AutomationRunID: { type: "Text", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_EmailTemplates: {
    TemplateCode: { type: "Text", required: true, unique: true },
    TemplateName: { type: "Text", required: true, unique: false },
    ProgramGroup: { type: "Choice", required: true, unique: false },
    CommunicationType: { type: "Choice", required: true, unique: false },
    RecipientType: { type: "Choice", required: true, unique: false },
    SubjectTemplate: { type: "Text", required: true, unique: false },
    BodyTemplate: { type: "Note", required: true, unique: false },
    RequiresStaffPreview: { type: "Boolean", required: false, unique: false },
    AutomaticSendingAllowed: { type: "Boolean", required: false, unique: false },
    Active: { type: "Boolean", required: false, unique: false },
    TemplateVersion: { type: "Text", required: true, unique: false },
    EffectiveStartDate: { type: "DateTime", required: false, unique: false },
    EffectiveEndDate: { type: "DateTime", required: false, unique: false },
    SupersedesTemplateCode: { type: "Text", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_FollowUpActions: {
    FollowUpActionID: { type: "Text", required: true, unique: true },
    FollowUpActionKey: { type: "Text", required: true, unique: true },
    SourceType: { type: "Choice", required: true, unique: false },
    SourceRecordID: { type: "Text", required: false, unique: false },
    ActionInstanceTag: { type: "Text", required: true, unique: false },
    FollowUpCategory: { type: "Choice", required: true, unique: false },
    FollowUpDescription: { type: "Note", required: true, unique: false },
    Status: { type: "Choice", required: true, unique: false },
    Priority: { type: "Choice", required: true, unique: false },
    PriorityRank: { type: "Number", required: true, unique: false },
    DueDateTime: { type: "DateTime", required: false, unique: false },
    AssignedTo: { type: "User", required: false, unique: false },
    AssignedGroup: { type: "Choice", required: true, unique: false },
    AssignedDateTime: { type: "DateTime", required: false, unique: false },
    TenantIDSnapshot: { type: "Text", required: false, unique: false },
    TenantNameSnapshot: { type: "Text", required: false, unique: false },
    UnitNumberSnapshot: { type: "Text", required: false, unique: false },
    AppointmentIDSnapshot: { type: "Text", required: false, unique: false },
    AppointmentStartSnapshot: { type: "DateTime", required: false, unique: false },
    VolunteerIDSnapshot: { type: "Text", required: false, unique: false },
    VolunteerNameSnapshot: { type: "Text", required: false, unique: false },
    ProgramCodeSnapshot: { type: "Text", required: false, unique: false },
    ServiceCompletionIDSnapshot: { type: "Text", required: false, unique: false },
    UnitConditionAssessmentIDSnapsho: { type: "Text", required: false, unique: false },
    CommunicationIDSnapshot: { type: "Text", required: false, unique: false },
    OriginatingEvent: { type: "Text", required: false, unique: false },
    EscalationLevel: { type: "Choice", required: true, unique: false },
    EscalatedDateTime: { type: "DateTime", required: false, unique: false },
    EscalatedTo: { type: "User", required: false, unique: false },
    ResolutionStatus: { type: "Choice", required: true, unique: false },
    ResolutionSummary: { type: "Note", required: false, unique: false },
    ResolvedBy: { type: "User", required: false, unique: false },
    ResolvedDateTime: { type: "DateTime", required: false, unique: false },
    ClosedBy: { type: "User", required: false, unique: false },
    ClosedDateTime: { type: "DateTime", required: false, unique: false },
    ReopenedCount: { type: "Number", required: true, unique: false },
    SensitiveContext: { type: "Boolean", required: true, unique: false },
    CorrelationID: { type: "Text", required: true, unique: false },
    AutomationRunID: { type: "Text", required: false, unique: false },
    CreationSource: { type: "Choice", required: true, unique: false },
    RelatedRecordLink: { type: "URL", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    Tenant: { type: "Lookup", required: false, unique: false },
    Appointment: { type: "Lookup", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_HousekeepingCapacityTransactions: {
    TransactionID: { type: "Text", required: true, unique: true },
    IdempotencyKey: { type: "Text", required: true, unique: true },
    CorrelationID: { type: "Text", required: true, unique: false },
    SubmittedDateTime: { type: "DateTime", required: true, unique: false },
    CreationSource: { type: "Choice", required: true, unique: false },
    RequestedByUser: { type: "User", required: false, unique: false },
    RequestedByEmailSnapshot: { type: "Text", required: true, unique: false },
    RequestedRoleContext: { type: "Choice", required: true, unique: false },
    RecordClass: { type: "Choice", required: true, unique: false },
    OperationType: { type: "Choice", required: false, unique: false },
    ProcessorAction: { type: "Choice", required: true, unique: false },
    ProcessingStatus: { type: "Choice", required: true, unique: false },
    ProcessingStage: { type: "Choice", required: true, unique: false },
    PostCommitStatus: { type: "Choice", required: true, unique: false },
    CompensationStatus: { type: "Choice", required: true, unique: false },
    RecoveryStatus: { type: "Choice", required: true, unique: false },
    ClaimedByRunID: { type: "Text", required: false, unique: false },
    ClaimedDateTime: { type: "DateTime", required: false, unique: false },
    ProcessingAttempts: { type: "Number", required: true, unique: false },
    LastAttemptDateTime: { type: "DateTime", required: false, unique: false },
    NextRetryEligibleDateTime: { type: "DateTime", required: false, unique: false },
    ProcessedDateTime: { type: "DateTime", required: false, unique: false },
    OutcomeCode: { type: "Choice", required: false, unique: false },
    OutcomeMessage: { type: "Text", required: false, unique: false },
    OutcomeIsRetryable: { type: "Boolean", required: true, unique: false },
    ResultingRecordID: { type: "Text", required: false, unique: false },
    ResultingAuditEventID: { type: "Text", required: false, unique: false },
    RequestSnapshotJSON: { type: "Note", required: true, unique: false },
    RequestSnapshotVersion: { type: "Text", required: true, unique: false },
    ExpectedCommunicationSetSnapshot: { type: "Note", required: true, unique: false },
    TargetSlotID: { type: "Text", required: true, unique: false },
    TargetServiceDateKey: { type: "Text", required: true, unique: false },
    TargetServiceDate: { type: "DateTime", required: true, unique: false },
    CurrentBaseCapacity: { type: "Number", required: true, unique: false },
    CurrentApprovedCapacity: { type: "Number", required: true, unique: false },
    RequestedAdditionalCapacity: { type: "Number", required: true, unique: false },
    ResultingApprovedCapacity: { type: "Number", required: false, unique: false },
    ApprovalStatus: { type: "Choice", required: true, unique: false },
    ApprovedBy: { type: "User", required: false, unique: false },
    ApprovedDateTime: { type: "DateTime", required: false, unique: false },
    DecisionReasonCategory: { type: "Choice", required: true, unique: false },
    WrittenJustification: { type: "Note", required: true, unique: false },
    CrewMemberAvailabilityConfirmed: { type: "Boolean", required: true, unique: false },
    PlannedCrewSizeSnapshot: { type: "Number", required: true, unique: false },
    IsAdvanceApproval: { type: "Boolean", required: true, unique: false },
    RevocationReasonCategory: { type: "Choice", required: true, unique: false },
    RevocationJustification: { type: "Note", required: false, unique: false },
    RevokedBy: { type: "User", required: false, unique: false },
    RevokedDateTime: { type: "DateTime", required: false, unique: false },
    ActiveDependentReservationCount: { type: "Number", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_HousekeepingSlots: {
    SlotID: { type: "Text", required: true, unique: true },
    ServiceDateKey: { type: "Text", required: true, unique: true },
    ServiceDate: { type: "DateTime", required: true, unique: false },
    SlotStatus: { type: "Choice", required: true, unique: false },
    PlannedBaseCapacity: { type: "Number", required: true, unique: false },
    PlannedCrewSize: { type: "Number", required: true, unique: false },
    CrewReadinessStatus: { type: "Choice", required: true, unique: false },
    DayStartTimeMinutes: { type: "Number", required: true, unique: false },
    DayEndTimeMinutes: { type: "Number", required: true, unique: false },
    SurgeCapacityApproved: { type: "Boolean", required: false, unique: false },
    GenerationSource: { type: "Choice", required: true, unique: false },
    SurgeApprovedDateTime: { type: "DateTime", required: false, unique: false },
    GeneratedDateTime: { type: "DateTime", required: false, unique: false },
    ReleasedForSchedulingDateTime: { type: "DateTime", required: false, unique: false },
    LastReviewedDate: { type: "DateTime", required: false, unique: false },
    SurgeApprovalReason: { type: "Note", required: false, unique: false },
    OperationsNotes: { type: "Note", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    ServiceCycle: { type: "Lookup", required: true, unique: false },
    BlackoutReference: { type: "Lookup", required: false, unique: false },
    SurgeApprovedBy: { type: "User", required: false, unique: false },
    ReleasedForSchedulingBy: { type: "User", required: false, unique: false },
    LastReviewedBy: { type: "User", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_Programs: {
    ProgramCode: { type: "Text", required: true, unique: true },
    ProgramName: { type: "Text", required: true, unique: false },
    SM_Programs: { type: "Choice", required: true, unique: false },
    RequiresVolunteer: { type: "Boolean", required: false, unique: false },
    RequiresHousekeepingSlot: { type: "Boolean", required: false, unique: false },
    DefaultDurationMinutes: { type: "Number", required: false, unique: false },
    Active: { type: "Boolean", required: false, unique: false },
    DisplayOrder: { type: "Number", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_ServiceCompletionTransactions: {
    TransactionID: { type: "Text", required: true, unique: true },
    IdempotencyKey: { type: "Text", required: true, unique: true },
    CorrelationID: { type: "Text", required: true, unique: false },
    SubmittedDateTime: { type: "DateTime", required: true, unique: false },
    CreationSource: { type: "Choice", required: true, unique: false },
    RequestedByUser: { type: "User", required: false, unique: false },
    RequestedByEmailSnapshot: { type: "Text", required: true, unique: false },
    RequestedRoleContext: { type: "Choice", required: true, unique: false },
    RecordClass: { type: "Choice", required: true, unique: false },
    OperationType: { type: "Choice", required: false, unique: false },
    ProcessorAction: { type: "Choice", required: true, unique: false },
    ProcessingStatus: { type: "Choice", required: true, unique: false },
    ProcessingStage: { type: "Choice", required: true, unique: false },
    PostCommitStatus: { type: "Choice", required: true, unique: false },
    CompensationStatus: { type: "Choice", required: true, unique: false },
    RecoveryStatus: { type: "Choice", required: true, unique: false },
    ClaimedByRunID: { type: "Text", required: false, unique: false },
    ClaimedDateTime: { type: "DateTime", required: false, unique: false },
    ProcessingAttempts: { type: "Number", required: true, unique: false },
    LastAttemptDateTime: { type: "DateTime", required: false, unique: false },
    NextRetryEligibleDateTime: { type: "DateTime", required: false, unique: false },
    ProcessedDateTime: { type: "DateTime", required: false, unique: false },
    OutcomeCode: { type: "Choice", required: false, unique: false },
    OutcomeMessage: { type: "Text", required: false, unique: false },
    OutcomeIsRetryable: { type: "Boolean", required: true, unique: false },
    ResultingRecordID: { type: "Text", required: false, unique: false },
    ResultingAuditEventID: { type: "Text", required: false, unique: false },
    RequestSnapshotJSON: { type: "Note", required: true, unique: false },
    RequestSnapshotVersion: { type: "Text", required: true, unique: false },
    ExpectedCommunicationSetSnapshot: { type: "Note", required: true, unique: false },
    TargetCompletionID: { type: "Text", required: false, unique: false },
    TargetAppointmentID: { type: "Text", required: true, unique: false },
    TargetTenantIDSnapshot: { type: "Text", required: true, unique: false },
    TargetServiceDate: { type: "DateTime", required: true, unique: false },
    RequestedCompletionStatus: { type: "Choice", required: true, unique: false },
    ServiceOutcome: { type: "Choice", required: true, unique: false },
    ServiceConditionLevel: { type: "Choice", required: true, unique: false },
    ReturnReasonCategory: { type: "Choice", required: true, unique: false },
    ReturnInstructions: { type: "Note", required: false, unique: false },
    VoidReasonCategory: { type: "Choice", required: true, unique: false },
    VoidJustification: { type: "Note", required: false, unique: false },
    CanonicalCompletionClaimKey: { type: "Text", required: false, unique: false },
    ResultingTombstoneKey: { type: "Text", required: false, unique: false },
    PredecessorCompletionID: { type: "Text", required: false, unique: false },
    AssessmentRequired: { type: "Boolean", required: true, unique: false },
    ResultingAssessmentID: { type: "Text", required: false, unique: false },
    AppointmentSyncOutcome: { type: "Choice", required: true, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_ServiceCompletions: {
    CompletionID: { type: "Text", required: true, unique: true },
    AppointmentCompletionKey: { type: "Text", required: true, unique: true },
    AppointmentIDSnapshot: { type: "Text", required: true, unique: false },
    TenantIDSnapshot: { type: "Text", required: true, unique: false },
    TenantNameSnapshot: { type: "Text", required: true, unique: false },
    UnitNumberAtService: { type: "Text", required: true, unique: false },
    ProgramCodeSnapshot: { type: "Text", required: true, unique: false },
    UnitConditionAssessmentID: { type: "Text", required: false, unique: false },
    CompletionStatus: { type: "Choice", required: true, unique: false },
    SubmissionSource: { type: "Choice", required: true, unique: false },
    ServiceOutcome: { type: "Choice", required: true, unique: false },
    ServiceDate: { type: "DateTime", required: true, unique: false },
    ServiceStartedDateTime: { type: "DateTime", required: false, unique: false },
    ServiceCompletedDateTime: { type: "DateTime", required: false, unique: false },
    OutcomeNotes: { type: "Note", required: false, unique: false },
    ConditionNotes: { type: "Note", required: false, unique: false },
    TenantInteractionDescription: { type: "Note", required: false, unique: false },
    ActualDurationMinutes: { type: "Number", required: false, unique: false },
    AdditionalServiceMinutesRecommen: { type: "Number", required: false, unique: false },
    PhotoCount: { type: "Number", required: true, unique: false },
    RoutineCompletion: { type: "Boolean", required: false, unique: false },
    AdditionalCleaningRecommended: { type: "Boolean", required: false, unique: false },
    TenantInteractionConcern: { type: "Boolean", required: false, unique: false },
    ServiceConditionLevel: { type: "Choice", required: true, unique: false },
    StaffFeltUnsafe: { type: "Boolean", required: false, unique: false },
    ImmediateAssistanceRequired: { type: "Boolean", required: false, unique: false },
    ImmediateHealthSafetyConcern: { type: "Boolean", required: false, unique: false },
    UnitConditionAssessmentRequired: { type: "Boolean", required: false, unique: false },
    UnitConditionAssessmentStatus: { type: "Choice", required: true, unique: false },
    UnitConditionAssessmentLink: { type: "URL", required: false, unique: false },
    PhotosAdded: { type: "Boolean", required: false, unique: false },
    PhotoReleaseVerified: { type: "Boolean", required: false, unique: false },
    PhotoDocumentationStatus: { type: "Choice", required: true, unique: false },
    PhotoNotesOrException: { type: "Note", required: false, unique: false },
    FollowUpRequired: { type: "Boolean", required: false, unique: false },
    FollowUpPriority: { type: "Choice", required: true, unique: false },
    FollowUpCategory: { type: "Choice", required: true, unique: false },
    FollowUpSummary: { type: "Note", required: false, unique: false },
    FollowUpStatus: { type: "Choice", required: true, unique: false },
    FollowUpRecordID: { type: "Text", required: false, unique: false },
    DocumentationFolderLink: { type: "URL", required: false, unique: false },
    CompletionSummaryDocumentLink: { type: "URL", required: false, unique: false },
    DocumentFilingStatus: { type: "Choice", required: true, unique: false },
    ReviewRequired: { type: "Boolean", required: false, unique: false },
    SubmittedBy: { type: "User", required: false, unique: false },
    SubmittedDateTime: { type: "DateTime", required: false, unique: false },
    ReviewedBy: { type: "User", required: false, unique: false },
    ReviewedDateTime: { type: "DateTime", required: false, unique: false },
    ReviewNotes: { type: "Note", required: false, unique: false },
    AppointmentSyncStatus: { type: "Choice", required: true, unique: false },
    AppointmentSyncDateTime: { type: "DateTime", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    Appointment: { type: "Lookup", required: true, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_ServiceCycles: {
    CycleCode: { type: "Text", required: true, unique: true },
    CycleName: { type: "Text", required: true, unique: false },
    CycleType: { type: "Choice", required: true, unique: false },
    ProgramGroup: { type: "Choice", required: false, unique: false },
    StartDate: { type: "DateTime", required: true, unique: false },
    EndDate: { type: "DateTime", required: true, unique: false },
    ActiveCycle: { type: "Boolean", required: false, unique: false },
    DisplayOrder: { type: "Number", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_Settings: {
    SettingKey: { type: "Text", required: true, unique: true },
    DisplayName: { type: "Text", required: true, unique: false },
    SettingValue: { type: "Text", required: true, unique: false },
    ValueType: { type: "Choice", required: true, unique: false },
    Category: { type: "Choice", required: true, unique: false },
    Description: { type: "Note", required: false, unique: false },
    Active: { type: "Boolean", required: true, unique: false },
    DisplayOrder: { type: "Number", required: false, unique: true },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_TenantProgramEnrollments: {
    EnrollmentID: { type: "Text", required: true, unique: true },
    EnrollmentStatus: { type: "Choice", required: true, unique: false },
    EnrollmentStartDate: { type: "DateTime", required: false, unique: false },
    EnrollmentEndDate: { type: "DateTime", required: false, unique: false },
    AuthorizationBasis: { type: "Choice", required: true, unique: false },
    AuthorizedAppointmentsPerCycle: { type: "Number", required: false, unique: false },
    SchedulingMethod: { type: "Choice", required: true, unique: false },
    AutoGenerateProposals: { type: "Boolean", required: false, unique: false },
    ConfirmationRequired: { type: "Boolean", required: false, unique: false },
    PrimaryWeekOfMonth: { type: "Choice", required: false, unique: false },
    PrimaryDayOfWeek: { type: "Choice", required: false, unique: false },
    PrimaryServicePeriod: { type: "Choice", required: false, unique: false },
    SecondaryWeekOfMonth: { type: "Choice", required: false, unique: false },
    SecondaryDayOfWeek: { type: "Choice", required: false, unique: false },
    SecondaryServicePeriod: { type: "Choice", required: false, unique: false },
    PatternEffectiveDate: { type: "DateTime", required: false, unique: false },
    ProposalsGeneratedThrough: { type: "DateTime", required: false, unique: false },
    EnrollmentApprovedBy: { type: "User", required: false, unique: false },
    EnrollmentApprovedDate: { type: "DateTime", required: false, unique: false },
    SchedulingNotes: { type: "Note", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    LastReviewedDate: { type: "DateTime", required: false, unique: false },
    Program: { type: "Lookup", required: true, unique: false },
    EligibilityStatus: { type: "Choice", required: true, unique: false },
    QueueStatus: { type: "Choice", required: true, unique: false },
    HousekeepingWaiverReceivedMethod: { type: "Choice", required: true, unique: false },
    ServiceSafetyHoldCategory: { type: "Choice", required: true, unique: false },
    EligibilityReason: { type: "Note", required: false, unique: false },
    HousekeepingWaiverCompleted: { type: "Boolean", required: false, unique: false },
    HousekeepingWaiverVersion: { type: "Text", required: false, unique: false },
    HousekeepingWaiverDate: { type: "DateTime", required: false, unique: false },
    HousekeepingWaiverVerifiedBy: { type: "User", required: false, unique: false },
    HousekeepingWaiverVerifiedDate: { type: "DateTime", required: false, unique: false },
    HousekeepingWaiverDocumentLink: { type: "URL", required: false, unique: false },
    HomeVisitCompleted: { type: "Boolean", required: false, unique: false },
    HomeVisitDate: { type: "DateTime", required: false, unique: false },
    HomeVisitCompletedBy: { type: "User", required: false, unique: false },
    HomeVisitNotes: { type: "Note", required: false, unique: false },
    ServiceSafetyHoldActive: { type: "Boolean", required: false, unique: false },
    ServiceSafetyHoldStartDate: { type: "DateTime", required: false, unique: false },
    ServiceSafetyHoldEndDate: { type: "DateTime", required: false, unique: false },
    RestrictedHoldNotes: { type: "Note", required: false, unique: false },
    EligibilityCalculatedDateTime: { type: "DateTime", required: false, unique: false },
    Tenant: { type: "Lookup", required: true, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_Tenants: {
    TenantID: { type: "Text", required: true, unique: true },
    FirstName: { type: "Text", required: true, unique: false },
    LastName: { type: "Text", required: true, unique: false },
    PreferredName: { type: "Text", required: false, unique: false },
    UnitNumber: { type: "Text", required: true, unique: false },
    EmailAddress: { type: "Text", required: false, unique: false },
    PhoneNumber: { type: "Text", required: false, unique: false },
    PreferredContactMethod: { type: "Choice", required: true, unique: false },
    EmailCommunicationAllowed: { type: "Boolean", required: false, unique: false },
    TextMessageAllowed: { type: "Boolean", required: false, unique: false },
    PhotoReleaseOnFile: { type: "Boolean", required: false, unique: false },
    PhotoReleaseDate: { type: "DateTime", required: false, unique: false },
    TenantStatus: { type: "Choice", required: true, unique: false },
    MoveInDate: { type: "DateTime", required: false, unique: false },
    MoveOutDate: { type: "DateTime", required: false, unique: false },
    SchedulingNotes: { type: "Note", required: false, unique: false },
    TenantFolderLink: { type: "URL", required: false, unique: false },
    LastVerifiedDate: { type: "DateTime", required: false, unique: false },
    TenantCategory: { type: "Choice", required: false, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_UnitConditionAssessments: {
    AssessmentID: { type: "Text", required: true, unique: true },
    ServiceCompletionKey: { type: "Text", required: true, unique: true },
    CompletionIDSnapshot: { type: "Text", required: true, unique: false },
    AppointmentIDSnapshot: { type: "Text", required: true, unique: false },
    TenantIDSnapshot: { type: "Text", required: true, unique: false },
    TenantNameSnapshot: { type: "Text", required: true, unique: false },
    UnitNumberAtService: { type: "Text", required: true, unique: false },
    ProgramCodeSnapshot: { type: "Text", required: true, unique: false },
    ServiceDate: { type: "DateTime", required: true, unique: false },
    AssessmentStatus: { type: "Choice", required: true, unique: false },
    SubmissionSource: { type: "Choice", required: true, unique: false },
    PrimaryConditionCategory: { type: "Choice", required: true, unique: false },
    ConditionsObserved: { type: "MultiChoice", required: true, unique: false },
    ConditionOtherDescription: { type: "Note", required: false, unique: false },
    AssessmentSeverityLevel: { type: "Choice", required: true, unique: false },
    ImmediateDangerPresent: { type: "Boolean", required: false, unique: false },
    ServiceStoppedOrUnitExited: { type: "Boolean", required: false, unique: false },
    SupervisorContacted: { type: "Boolean", required: false, unique: false },
    BuildingManagementContacted: { type: "Boolean", required: false, unique: false },
    EmergencyAssistanceContacted: { type: "Boolean", required: false, unique: false },
    UrgentAlertRequired: { type: "Boolean", required: false, unique: false },
    UrgentAlertStatus: { type: "Choice", required: true, unique: false },
    UrgentAlertSentDateTime: { type: "DateTime", required: false, unique: false },
    EscalationNotes: { type: "Note", required: false, unique: false },
    ObservationSummary: { type: "Note", required: true, unique: false },
    AreasAffected: { type: "Note", required: false, unique: false },
    EffectOnScheduledService: { type: "Choice", required: true, unique: false },
    FollowUpRecommended: { type: "Boolean", required: false, unique: false },
    RecommendedFollowUp: { type: "Note", required: false, unique: false },
    FollowUpPriority: { type: "Choice", required: true, unique: false },
    FollowUpCategory: { type: "Choice", required: true, unique: false },
    PhotosAdded: { type: "Boolean", required: false, unique: false },
    PhotoCount: { type: "Number", required: true, unique: false },
    PhotoReleaseVerified: { type: "Boolean", required: false, unique: false },
    PhotoDocumentationStatus: { type: "Choice", required: true, unique: false },
    PhotoNotesOrException: { type: "Note", required: false, unique: false },
    DocumentationFolderLink: { type: "URL", required: false, unique: false },
    AssessmentDocumentLink: { type: "URL", required: false, unique: false },
    DocumentFilingStatus: { type: "Choice", required: true, unique: false },
    SubmittedBy: { type: "User", required: false, unique: false },
    SubmittedDateTime: { type: "DateTime", required: false, unique: false },
    ReviewRequired: { type: "Boolean", required: false, unique: false },
    ReviewedBy: { type: "User", required: false, unique: false },
    ReviewedDateTime: { type: "DateTime", required: false, unique: false },
    ReviewNotes: { type: "Note", required: false, unique: false },
    CompletionSyncStatus: { type: "Choice", required: true, unique: false },
    CompletionSyncDateTime: { type: "DateTime", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
    ServiceCompletion: { type: "Lookup", required: true, unique: false },
    ContentType: { type: "Computed", required: false, unique: false },
    Attachments: { type: "Attachments", required: false, unique: false },
  },
  SM_TenantFeedback: {
    FeedbackID: { type: "Text", required: true, unique: true, maxLength: 40, indexed: true },
    TenantIDSnapshot: { type: "Text", required: true, unique: false, maxLength: 50, indexed: true },
    TenantNameSnapshot: { type: "Text", required: true, unique: false, maxLength: 200 },
    UnitNumberSnapshot: { type: "Text", required: true, unique: false, maxLength: 20 },
    AppointmentIDSnapshot: { type: "Text", required: false, unique: false, maxLength: 50 },
    SubmittedDateTime: { type: "DateTime", required: true, unique: false, indexed: true },
    Channel: { type: "Choice", required: true, unique: false, defaultValue: "Email link" },
    FormLanguage: { type: "Choice", required: true, unique: false, defaultValue: "English" },
    LinkToken: { type: "Text", required: false, unique: false, maxLength: 120, indexed: true },
    EnteredByEmailSnapshot: { type: "Text", required: false, unique: false, maxLength: 128 },
    EnteredByNameSnapshot: { type: "Text", required: false, unique: false, maxLength: 150 },
    Satisfied: { type: "Number", required: true, unique: false },
    BelongingsCare: { type: "Choice", required: true, unique: false, defaultValue: "Not Answered" },
    Suggestions: { type: "Note", required: false, unique: false },
    ContinueService: { type: "Choice", required: true, unique: false, defaultValue: "Not Answered" },
    AdditionalComments: { type: "Note", required: false, unique: false },
    IsComplaint: { type: "Boolean", required: false, unique: false },
    ComplaintWhat: { type: "Note", required: false, unique: false },
    ComplaintVisitDate: { type: "DateTime", required: false, unique: false },
    RoutedTo: { type: "Text", required: false, unique: false, maxLength: 255 },
    RoutedDateTime: { type: "DateTime", required: false, unique: false },
    FollowUpActionIDSnapshot: { type: "Text", required: false, unique: false, maxLength: 40 },
    FeedbackStatus: { type: "Choice", required: true, unique: false, defaultValue: "New" },
    DocumentLink: { type: "URL", required: false, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
  },
  SM_Events: {
    EventID: { type: "Text", required: true, unique: true, maxLength: 40, indexed: true },
    EventDateKey: { type: "Text", required: true, unique: false, maxLength: 8, indexed: true },
    EventDate: { type: "DateTime", required: true, unique: false },
    StartTimeMinutes: { type: "Number", required: false, unique: false },
    EndTimeMinutes: { type: "Number", required: false, unique: false },
    EventLocation: { type: "Text", required: true, unique: false, maxLength: 255 },
    IsOffSite: { type: "Boolean", required: false, unique: false },
    EventAddress: { type: "Text", required: false, unique: false, maxLength: 255 },
    DirectionsUrl: { type: "URL", required: false, unique: false },
    EventDescription: { type: "Note", required: false, unique: false },
    SpotRule: { type: "Choice", required: true, unique: false, defaultValue: "Everyone" },
    Capacity: { type: "Number", required: false, unique: false },
    Tickets: { type: "Number", required: false, unique: false },
    MaxPerHousehold: { type: "Number", required: false, unique: false },
    Audience: { type: "Choice", required: true, unique: false, defaultValue: "Tenants" },
    VolunteerAudience: { type: "Choice", required: true, unique: false, defaultValue: "Not Applicable" },
    VolunteersNeeded: { type: "Number", required: false, unique: false },
    EventStatus: { type: "Choice", required: true, unique: false, defaultValue: "Draft" },
    RSVPCloseDateKey: { type: "Text", required: false, unique: false, maxLength: 8 },
    RaffleSeed: { type: "Text", required: false, unique: false, maxLength: 80 },
    RaffleDrawnDateTime: { type: "DateTime", required: false, unique: false },
    RaffleDrawnByEmailSnapshot: { type: "Text", required: false, unique: false, maxLength: 128 },
    RaffleHistory: { type: "Note", required: false, unique: false },
    LinkedGroupEventKey: { type: "Text", required: false, unique: false, maxLength: 100 },
    CountsForVISIONS: { type: "Boolean", required: false, unique: false },
    FolderLink: { type: "URL", required: false, unique: false },
    CreatedByEmailSnapshot: { type: "Text", required: true, unique: false, maxLength: 128 },
    CreatedDateTime: { type: "DateTime", required: true, unique: false },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
  },
  SM_EventRSVPs: {
    RSVPID: { type: "Text", required: true, unique: true, maxLength: 40, indexed: true },
    EventIDSnapshot: { type: "Text", required: true, unique: false, maxLength: 40, indexed: true },
    RSVPKey: { type: "Text", required: true, unique: true, maxLength: 150, indexed: true },
    PersonType: { type: "Choice", required: true, unique: false, defaultValue: "Tenant" },
    TenantIDSnapshot: { type: "Text", required: false, unique: false, maxLength: 50, indexed: true },
    VolunteerIDSnapshot: { type: "Text", required: false, unique: false, maxLength: 50, indexed: true },
    PersonName: { type: "Text", required: true, unique: false, maxLength: 200 },
    UnitNumberSnapshot: { type: "Text", required: false, unique: false, maxLength: 20 },
    PhoneNumber: { type: "Text", required: false, unique: false, maxLength: 50 },
    EmailAddress: { type: "Text", required: false, unique: false, maxLength: 255 },
    HouseholdKey: { type: "Text", required: false, unique: false, maxLength: 100, indexed: true },
    Coming: { type: "Choice", required: true, unique: false, defaultValue: "No Answer" },
    HouseholdCount: { type: "Number", required: false, unique: false },
    GuestCount: { type: "Number", required: false, unique: false },
    AttendingCount: { type: "Number", required: false, unique: false },
    Accessibility: { type: "Choice", required: false, unique: false, multi: true },
    Transportation: { type: "Choice", required: true, unique: false, defaultValue: "N/A" },
    RSVPNotes: { type: "Note", required: false, unique: false },
    IsStandby: { type: "Boolean", required: false, unique: false },
    StandbyRank: { type: "Number", required: false, unique: false },
    Tickets: { type: "Number", required: false, unique: false },
    RaffleRank: { type: "Number", required: false, unique: false },
    RaffleOutcome: { type: "Choice", required: true, unique: false, defaultValue: "Not Applicable" },
    CheckedIn: { type: "Boolean", required: false, unique: false },
    CheckedInDateTime: { type: "DateTime", required: false, unique: false },
    CheckedInByEmailSnapshot: { type: "Text", required: false, unique: false, maxLength: 128 },
    ConfirmedByPhone: { type: "Boolean", required: false, unique: false },
    CalledByEmailSnapshot: { type: "Text", required: false, unique: false, maxLength: 128 },
    CalledDateTime: { type: "DateTime", required: false, unique: false },
    CallOutcome: { type: "Choice", required: true, unique: false, defaultValue: "Not Applicable" },
    EntryChannel: { type: "Choice", required: true, unique: false, defaultValue: "Link" },
    EnteredByEmailSnapshot: { type: "Text", required: false, unique: false, maxLength: 128 },
    LinkToken: { type: "Text", required: true, unique: true, maxLength: 120, indexed: true },
    RespondedDateTime: { type: "DateTime", required: false, unique: false },
    LastChangedDateTime: { type: "DateTime", required: false, unique: false },
    RSVPStatus: { type: "Choice", required: true, unique: false, defaultValue: "Active" },
    SupersededByRSVPID: { type: "Text", required: false, unique: false, maxLength: 40 },
    AdministrativeNotes: { type: "Note", required: false, unique: false },
  },
};

/** The value docs/SCHEMA-V4-ADDITIONS.md §5 appends to SM_AppointmentTransactions.RequestedRoleContext. */
export const TENANT_SELF_SERVICE_ROLE_CONTEXT = "Tenant Self-Service";
